import React, { FC, memo } from "react";
import { InputNumber } from "antd";
import { GroupBlockEntityType } from "../../../../configMap";
import useEditEntityNumber from "../../hooks/useEditEntityNumber";

type EditEntityNumberProps = {
  entityType: GroupBlockEntityType;
  documentId: string;
  annotationId: string;
  defaultValue: number;
  groupBlockIndex: number;
  isTableMode: boolean;
};

const EditEntityNumber: FC<EditEntityNumberProps> = ({
  entityType,
  documentId,
  annotationId,
  defaultValue,
  groupBlockIndex,
  isTableMode,
}: EditEntityNumberProps) => {
  const {
    value,
    setValue,
    handleStep,
    handleEnter,
    onBlur,
    handleCancel,
    handleKeyEvent,
  } = useEditEntityNumber({
    entityType,
    documentId,
    annotationId,
    defaultValue,
    groupBlockIndex,
    isTableMode,
  });

  if (isTableMode) {
    return (
      <div className="edit-entity--table edit-entity-number">
        <InputNumber
          size={"small"}
          defaultValue={value ? value : undefined}
          decimalSeparator={","}
          value={value}
          onStep={handleStep}
          onChange={setValue}
          onPressEnter={handleEnter}
          onBlur={onBlur}
          onClick={(e) => {
            e.stopPropagation();
          }}
          autoFocus
          onKeyDown={handleKeyEvent}
          autoComplete="off"
        />

        <div className="edit-actions">
          <i className="bi bi-slash-circle cancel" onMouseDown={handleCancel} />
          <i className="bi bi-check-lg submit" onMouseDown={handleEnter} />
        </div>
      </div>
    );
  }

  return (
    <span className="edit-entity--side edit-entity-number">
      <InputNumber
        size={"small"}
        defaultValue={value ? value : undefined}
        decimalSeparator={","}
        value={value}
        onStep={handleStep}
        onChange={setValue}
        onPressEnter={handleEnter}
        onBlur={onBlur}
        onClick={(e) => {
          e.stopPropagation();
        }}
        autoFocus
        onKeyDown={handleKeyEvent}
        autoComplete="off"
      />

      <span className="edit-entity-actions">
        <i className="bi bi-slash-circle cancel" onMouseDown={handleCancel} />
        <i className="bi bi-check-lg submit" onMouseDown={handleEnter} />
      </span>
    </span>
  );
};

export default memo(EditEntityNumber);
